import React from 'react'

import ColumnGridPanel from 'components/ColumnGridPanel'

import ConfigDropdown from 'pages/Device/SystemConfigPanel/ConfigDropdown'

import { SystemConfigReport, SystemConfiguration } from 'types/SystemConfigReport'

import { friendlyName } from 'helpers/formatters'
import styled from 'styled-components'
import { NoData } from 'styles/shared'
import { scrubNumber } from 'helpers/inputCleaners'
import { OUTDOOR_STAGES, OUTDOOR_UNIT_TYPE, COMPRESSOR_TYPE, REFRIGERANT_TYPE, OUTDOOR_UNIT_TONNAGES } from 'helpers/reportFriendlyNames'
export type Props = Partial<SystemConfigReport> & {
  isEditing: boolean
  onChangeCallback: (arg: Partial<SystemConfiguration>) => void
  readOnlyRefrigerantType: boolean
}

const OutdoorUnit = ({ isEditing, onChangeCallback, readOnlyRefrigerantType, ...report }: Props) => {
  const refrigerantOptions = [...Object.keys(REFRIGERANT_TYPE).map(key => [{ value: key, name: friendlyName(key, REFRIGERANT_TYPE) }])]
  const outdoorUnitTonnageOptions = [...OUTDOOR_UNIT_TONNAGES.map((outdoorUnitTonnage) => [{ value: outdoorUnitTonnage, name: friendlyName(outdoorUnitTonnage) }])]

  return (
    <ColumnGridPanel.Column>
      <ColumnGridPanel.Column.Header>Outdoor Unit</ColumnGridPanel.Column.Header>
      {report.outdoorUnitType && report.outdoorUnitType.toLowerCase() !== 'none'
        ? (
          <>
            <ColumnGridPanel.Column.Item label="OD Unit Type" value={friendlyName(report.outdoorUnitType, OUTDOOR_UNIT_TYPE)} />
            <ColumnGridPanel.Column.Item label="OD Unit Stages" value={friendlyName(report.outdoorStage || 'N/A', OUTDOOR_STAGES)} />
            <ColumnGridPanel.Column.Item label="Compressor Type" value={friendlyName(report.compressorType || 'N/A', COMPRESSOR_TYPE)} />

            <ColumnGridPanel.Column.Item label="Outdoor Unit Tonnage"
                  value={<ConfigDropdown autoFocus isEditing={isEditing} options={outdoorUnitTonnageOptions} value={report.outdoorUnitTonnage}
                  onChangeCallback={(value) => onChangeCallback({ outdoorUnitTonnage: scrubNumber(value, true) })}
                         />}
            />

            <ColumnGridPanel.Column.Item
              label="Refrigerant Type"
              value={
                <ConfigDropdown
                  isEditing={readOnlyRefrigerantType ? false : isEditing}
                  value={report.refrigerantType}
                  options={refrigerantOptions}
                  onChangeCallback={(value) => onChangeCallback({ userSelectedRefrigerantType: value as string })}
                />
              }
            />
          </>
        )
        : <S.NoData> <h1>No Outdoor Unit Configured</h1> </S.NoData>
      }
    </ColumnGridPanel.Column>
  )
}

export default OutdoorUnit

const S = {
  NoData: styled(NoData)`
    h1 {
      padding-left:20px;
      padding-right:20px;
      font-size: 24px;
    }
  `
}
